// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdfEdit_page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 48px);
}
.pdfEdit_page .pdf_top {
  height: 40px;
  background: #192234;
}
.pdfEdit_page .pdf_bottom {
  flex: 1;
  color: #fff;
  display: flex;
}
.pdfEdit_page .ant-splitter-horizontal > .ant-splitter-bar .ant-splitter-bar-dragger:before {
  width: 0.25rem !important;
}
.pdfEdit_page .ant-splitter-vertical > .ant-splitter-bar .ant-splitter-bar-dragger:before {
  height: 0.25rem !important;
}
.pdfEdit_page .ant-splitter-horizontal > .ant-splitter-bar .ant-splitter-bar-collapse-bar-start {
  display: none;
}
.pdfEdit_page .ant-splitter > .ant-splitter-bar .ant-splitter-bar-dragger:hover:not(.ant-splitter-bar-dragger-active):before {
  background: hsl(var(--primary) / 0.4);
}
.pdfEdit_page .ant-btn {
  margin-top: 3px;
  margin-left: 5px;
  background: linear-gradient(to bottom, #4a5467 0, #4a5467 100%);
}
.pdfEdit_page .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):active,
.pdfEdit_page .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
  background: #4c5465 !important;
}
.pdfEdit_page .ant-btn-variant-solid:disabled {
  border-color: transparent;
  color: #929090;
  background: #4C5465;
}
.pdfEdit_page .pdf_template {
  width: 200px;
  height: 100%;
  border-right: 8px solid #444444;
}
.pdfEdit_page .pdf_template_title {
  width: 100%;
  height: 35px;
  background: #424650;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
}
.pdfEdit_page .pdf_template_left_content {
  height: 60%;
}
.pdfEdit_page .radio_box {
  margin: 10px 5px;
}
.pdfEdit_page h3 {
  font-size: 16px !important;
}
.pdfEdit_page .pdf_content {
  padding-left: 20px;
}
.pdfEdit_page .ant-radio-wrapper .ant-radio {
  color: #fff !important;
}
.pdfEdit_page .ant-tree [class^="ant-tree"] {
  color: #fff;
  background: #2e3440;
}
.pdfEdit_page .ant-splitter-horizontal > .ant-splitter-bar .ant-splitter-bar-dragger:before {
  width: 6px;
  background: #252a33;
}
.pdfEdit_page .ant-splitter-vertical > .ant-splitter-bar .ant-splitter-bar-dragger:before {
  height: 6px;
  background: #252a33;
}
.pdfEdit_page .ant-form-item {
  margin: 10px 5px 0px 0;
}
.pdfEdit_page .ant-radio-wrapper span.ant-radio + * {
  color: #fff;
}
.pdfEdit_page .ant-col span {
  width: 40%;
}
.pdfEdit_page .ant-form-item .ant-form-item-label > label {
  width: 90px;
  justify-content: flex-end;
}
.pdfEdit_page .ant-input-outlined.ant-input-disabled,
.pdfEdit_page .ant-input-outlined[disabled] {
  background: #c7c7c7;
}
.pdfEdit_page .tab_box {
  margin-top: 10px;
}
.pdfEdit_page .tab_box .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.pdfEdit_page .tab_box .ant-tabs .ant-tabs-tab-btn {
  color: #fff;
}
.pdfEdit_page .tab_box .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,
.pdfEdit_page .tab_box .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  background: #4a5467;
}
.pdfEdit_page .tab_box .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
.pdfEdit_page .tab_box .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  border-color: #000;
  padding: 5px 8px;
}
.pdfEdit_page .tab_box .ant-tabs-top > .ant-tabs-nav::before,
.pdfEdit_page .tab_box .ant-tabs-bottom > .ant-tabs-nav::before,
.pdfEdit_page .tab_box .ant-tabs-top > div > .ant-tabs-nav::before,
.pdfEdit_page .tab_box .ant-tabs-bottom > div > .ant-tabs-nav::before {
  border-bottom: 1px solid #000;
}
.pdfEdit_page .tab_box .ant-tabs .ant-tabs-tabpane {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/PdfEdit/PdfEdit.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;AACF;AALA;EAOI,YAAA;EACA,mBAAA;AACJ;AATA;EAaI,OAAA;EACA,WAAA;EACA,aAAA;AADJ;AAdA;EAmBI,yBAAA;AAFJ;AAjBA;EAuBI,0BAAA;AAHJ;AApBA;EA2BI,aAAA;AAJJ;AAvBA;EA+BI,qCAAA;AALJ;AA1BA;EAmCI,eAAA;EACA,gBAAA;EACA,+DAAA;AANJ;AA/BA;;EAyCI,8BAAA;AANJ;AAnCA;EA8CI,yBAAA;EACA,cAAA;EACA,mBAAA;AARJ;AAxCA;EAoDI,YAAA;EACA,YAAA;EACA,+BAAA;AATJ;AA7CA;EA0DI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AAVJ;AAvDA;EAqEI,WAAA;AAXJ;AA1DA;EAyEI,gBAAA;AAZJ;AA7DA;EA6EI,0BAAA;AAbJ;AAhEA;EAiFI,kBAAA;AAdJ;AAnEA;EAqFI,sBAAA;AAfJ;AAtEA;EAyFI,WAAA;EACA,mBAAA;AAhBJ;AA1EA;EA8FI,UAAA;EACA,mBAAA;AAjBJ;AA9EA;EAmGI,WAAA;EACA,mBAAA;AAlBJ;AAlFA;EAwGI,sBAAA;AAnBJ;AArFA;EA4GI,WAAA;AApBJ;AAxFA;EAgHI,UAAA;AArBJ;AA3FA;EAoHI,WAAA;EACA,yBAAA;AAtBJ;AA/FA;;EAyHI,mBAAA;AAtBJ;AAnGA;EA6HI,gBAAA;AAvBJ;AAtGA;EAgIM,WAAA;AAvBN;AAzGA;EAoIM,WAAA;AAxBN;AA5GA;;EAwIM,mBAAA;AAxBN;AAhHA;;EA4IM,kBAAA;EACA,gBAAA;AAxBN;AArHA;;;;EAiJM,6BAAA;AAtBN;AA3HA;EAqJM,WAAA;AAvBN","sourcesContent":[".pdfEdit_page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: calc(100vh - 48px);\n\n  .pdf_top {\n    height: 40px;\n    background: #192234;\n  }\n\n\n  .pdf_bottom {\n    flex: 1;\n    color: #fff;\n    display: flex;\n  }\n\n  .ant-splitter-horizontal > .ant-splitter-bar .ant-splitter-bar-dragger:before{\n    width:0.25rem !important;\n  }\n\n  .ant-splitter-vertical > .ant-splitter-bar .ant-splitter-bar-dragger:before{\n    height:0.25rem !important;\n  }\n\n  .ant-splitter-horizontal >.ant-splitter-bar .ant-splitter-bar-collapse-bar-start{\n    display:none;\n  }\n\n  .ant-splitter >.ant-splitter-bar .ant-splitter-bar-dragger:hover:not(.ant-splitter-bar-dragger-active):before{\n    background:hsl(var(--primary) / .40);\n  }\n\n  .ant-btn {\n    margin-top: 3px;\n    margin-left: 5px;\n    background:linear-gradient(to bottom, #4a5467 0, #4a5467 100%);\n  }\n\n  .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):active,.ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover{\n    background:#4c5465 !important;\n  }\n\n\n  .ant-btn-variant-solid:disabled {\n    border-color: transparent;\n    color: #929090;\n    background:#4C5465;\n  }\n\n  .pdf_template {\n    width: 200px;\n    height: 100%;\n    border-right: 8px solid #444444;\n  }\n\n  .pdf_template_title {\n    width: 100%;\n    height: 35px;\n    background: #424650;\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 5px;\n  }\n\n  .pdf_template_left_content {\n    height: 60%;\n  }\n\n  .radio_box {\n    margin: 10px 5px;\n  }\n\n  h3 {\n    font-size:16px !important;\n  }\n\n  .pdf_content {\n    padding-left: 20px;\n  }\n\n  .ant-radio-wrapper .ant-radio {\n    color: #fff !important;\n  }\n\n  .ant-tree [class^=\"ant-tree\"] {\n    color: #fff;\n    background: #2e3440;\n  }\n\n  .ant-splitter-horizontal>.ant-splitter-bar .ant-splitter-bar-dragger:before {\n    width: 6px;\n    background: #252a33;\n  }\n\n  .ant-splitter-vertical>.ant-splitter-bar .ant-splitter-bar-dragger:before {\n    height: 6px;\n    background: #252a33;\n  }\n\n  .ant-form-item {\n    margin: 10px 5px 0px 0;\n  }\n\n  .ant-radio-wrapper span.ant-radio+*{\n    color:#fff;\n  }\n\n  .ant-col span{\n    width:40%;\n  }\n\n  .ant-form-item .ant-form-item-label >label{\n    width:90px;\n    justify-content: flex-end;\n  }\n\n  .ant-input-outlined.ant-input-disabled, .ant-input-outlined[disabled]{\n    background:#c7c7c7;\n  }\n\n  .tab_box{\n    margin-top:10px;\n\n    .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{\n      color:#fff;\n    }\n\n    .ant-tabs .ant-tabs-tab-btn{\n      color:#fff;\n    }\n\n    .ant-tabs-card >.ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card >div>.ant-tabs-nav .ant-tabs-tab-active{\n      background:#4a5467;\n    }\n\n    .ant-tabs-card >.ant-tabs-nav .ant-tabs-tab, .ant-tabs-card >div>.ant-tabs-nav .ant-tabs-tab{\n      border-color:#000;\n      padding:5px 8px;\n    }\n\n    .ant-tabs-top >.ant-tabs-nav::before, .ant-tabs-bottom >.ant-tabs-nav::before, .ant-tabs-top >div>.ant-tabs-nav::before, .ant-tabs-bottom >div>.ant-tabs-nav::before{\n      border-bottom:1px solid #000;\n    }\n\n    .ant-tabs .ant-tabs-tabpane{\n      color:#fff;\n    }\n\n\n  }\n\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
